/* KinderSpeech szülinapi visszaszámláló (evergreen, cookie-alapú)
   - Első látogatáskor a cookie-ba kerül egy határidő (most + duration).
   - Lejáratkor 0:00:00-n megáll, majd restart-hours órával később újraindul.
   - A cookie legfeljebb 30 napig él (Safari kb. 7 napra rövidíti), minden
     oldalon ugyanazt a határidőt mutatja.
   - Idempotens: a témaszerkesztő section-újrarenderelése után is jól működik. */
(function () {
  var NAME = 'ks_bday_deadline';

  function most() {
    return Math.floor(Date.now() / 1000);
  }
  function getCookie() {
    var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + NAME + '=(\\d+)'));
    return m ? parseInt(m[1], 10) : null;
  }
  function setCookie(val) {
    document.cookie = NAME + '=' + val + '; max-age=2592000; path=/; SameSite=Lax; Secure';
  }

  function initEl(el) {
    if (el.__ksbdayInterval) return; /* ezen az elemen már fut */
    var out = el.querySelector('[data-ksbday-digits]');
    if (!out) return;

    var DURATION = parseInt(el.getAttribute('data-duration'), 10);
    if (!DURATION || DURATION < 60) DURATION = 14207; /* 3:56:47 */
    var RESTART_AFTER = parseInt(el.getAttribute('data-restart-hours'), 10);
    RESTART_AFTER = (RESTART_AFTER > 0 ? RESTART_AFTER : 6) * 3600;

    function ujHatarido() {
      var d = most() + DURATION;
      setCookie(d);
      return d;
    }

    var deadline = getCookie();
    /* nincs cookie, értelmetlen érték, vagy a jövőbe lőtt határidő: újraindul */
    if (!deadline || deadline - most() > DURATION) {
      deadline = ujHatarido();
    } else {
      /* érvényes cookie: max-age frissítés, hogy tovább éljen */
      setCookie(deadline);
    }

    function pad(n) {
      return (n < 10 ? '0' : '') + n;
    }
    function tick() {
      /* a témaszerkesztő újrarendereli a sectiont: levált elemen leáll */
      if (!document.contains(el)) {
        clearInterval(el.__ksbdayInterval);
        el.__ksbdayInterval = null;
        return;
      }
      var now = most();
      /* más fülön újraindulhatott közben: mindig a cookie az igazság */
      var cd = getCookie();
      if (cd && cd !== deadline && cd - now <= DURATION) deadline = cd;

      var rem = deadline - now;
      if (rem <= 0) {
        if (now - deadline >= RESTART_AFTER) {
          deadline = ujHatarido();
          rem = deadline - now;
        } else {
          rem = 0;
        }
      }
      var h = Math.floor(rem / 3600);
      var m = Math.floor((rem % 3600) / 60);
      var s = rem % 60;
      out.textContent = h + ':' + pad(m) + ':' + pad(s);
    }

    tick();
    el.hidden = false;
    el.__ksbdayInterval = setInterval(tick, 1000);
  }

  function initAll(root) {
    var list = (root || document).querySelectorAll('[data-ksbday-timer]');
    for (var i = 0; i < list.length; i++) initEl(list[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* Shopify témaszerkesztő: újrarender után újrainit, eltávolításkor takarítás */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var list = e.target.querySelectorAll('[data-ksbday-timer]');
    for (var i = 0; i < list.length; i++) {
      if (list[i].__ksbdayInterval) clearInterval(list[i].__ksbdayInterval);
    }
  });
})();
